__webpack_require__.p = "/pax/west2024/";